export default "__VITE_PUBLIC_ASSET__18148c78__"